import { CartResponse, CartStatus } from '@models/cart';
import { ItemResponse } from '@models/item';
import { CreateOrderRequest, OptionWithGroup, OrderLine } from '@models/order';
import { ShopResponse } from '@models/shop';
import orderWithTotalAmount from '@providers/OrderProvider/utils/orderWithTotalAmount';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export interface PrepareOrderInfo {
    shop: ShopResponse;
    items: ItemResponse[];
    projectId: string;
}

const makeOptions = (
  item: ItemResponse,
  optionType: 'PERSONAL'|'DEFAULT',
): OptionWithGroup[] => {
  const optionGroups = optionType === 'PERSONAL'
    ? item.personalOptionGroups : item.defaultOptionGroups;
    // 모든 옵션의 종류를 추가
  return optionGroups.map((optionGroup) => {
    const options = optionGroup.options
    // 기본값인 경우 주문에 추가
      .filter((option) => option.isDefault)
      .map((option) => {
        const {
          optionId, name, salePrice, isChangeable, maxQuantity,
        } = option;
        return {
          shopOptionId: optionId,
          optionName: name,
          optionPrice: salePrice,
          quantity: 1,
          totalAmount: salePrice,
          isChangeable,
          optionGroupId: optionGroup.optionGroupId,
          maxQuantity,
        };
      });
    return {
      optionGroupId: optionGroup.optionGroupId,
      minSelection: optionGroup.minSelection,
      maxSelection: optionGroup.maxSelection,
      options,
    };
  });
};

export function prepare(state: WritableDraft<CreateOrderRequest>, action: PayloadAction<PrepareOrderInfo>) {
  const { shop, items, projectId } = action.payload;
  state.shopId = shop.id;
  state.shopName = shop.name;
  state.orderLines = [];

  const makeOrderItems = (): OrderLine[] => items?.map((item) => {
    const {
      id, name, salePrice, couponUsable,
    } = item;
    return {
      shopItemId: id,
      thumbnailImage: item.imageUrls?.[0] || '',
      defaultOptions: makeOptions(item, 'DEFAULT'),
      personalOptions: makeOptions(item, 'PERSONAL'),
      itemName: name,
      itemPrice: salePrice,
      totalAmount: salePrice,
      quantity: 1,
      itemImageUrl: item.imageUrls[0],
      couponUsable,
      status: CartStatus.ON_SALE,
    };
  }) || [];

  const newDefaultValue: CreateOrderRequest = {
    projectId,
    shopId: shop?.id || '',
    shopName: shop?.name || '',
    orderPath: 'DIRECT',
    orderType: 'TAKE_OUT',
    totalAmount: 0,
    totalDiscount: 0,
    totalCouponDiscount: 0,
    totalGiftDiscount: 0,
    totalPointDiscount: 0,
    orderLines: makeOrderItems(),
    paymentAmount: 0,
    paymentMethod: 'CREDIT_CARD',
    returnUrl: '',
  };
  Object.assign(state, newDefaultValue);
}
